import { commonDate } from 'src/helpers'

function parseDate (date) {
  return date
    ? commonDate({ useDayName: true, date: new Date(date) })
    : '-'
}

export default function () {
  return {
    table: {
      products: {
        columns: [
          {
            name: 'product',
            label: 'Nama Produk',
            align: 'left',
            field: row => {
              const renderVariant = () => {
                let el = ''
                row.product.variant.forEach(variant => {
                  el += `
                    <span class="custom-badge-small custom-badge-green dense w-auto q-mr-xs q-mb-xs text-capitalize">
                      ${variant.value}
                    </span>
                  `
                })
                return el
              }

              return `
                <strong
                  class="ellipsis-3-lines"
                  style="min-width: 150px;"
                >
                  ${row.product.fullName}
                </strong>
                <div>No SKU: ${row.product.sku}</div>
                <div>${renderVariant()}</div>
                <a href="#" class="open-note" data-note="${row.product.note}">Lihat Catatan</a>
              `
            }
          },
          {
            name: 'deliveryAt',
            field: row => parseDate(row.deliveryAt),
            label: 'Tanggal Barang Dikirim',
            align: 'left'
          },
          {
            name: 'qty',
            field: row => `${row.qty}/${row.defaultQty} ${row.product?.product?.unit?.name || ''
            }`,
            label: 'Jumlah',
            align: 'left',
            rowClass: 'text-no-wrap'
          }
        ]
      }
    }
  }
}
